<template>
    <v-container>
        <v-layout column>
            <v-flex>
                <div class="headline mt-3 text-center">Hur jämnställd är musiken som spelas på svensk radio?</div>
                <p class="subheading mt-5 text-center">
                    Utforska fördelningen mellan kvinnliga, manliga, 
                    och icke-binära musiker i låtarna som spelas av Sveriges Radio, Bauer Media Sverige, och Nordic Entertainment Group.
                </p>
            </v-flex>
        </v-layout>
        <!--<v-divider></v-divider>-->
    </v-container>
</template>

<script>
export default {
    name: "Introduction"
};
</script>
